<script>
    import R, {LOADER} from "../lib/requests";
    import {PASSPORT_STATUS} from "../lib/constants";
    import passportsStore from "../stores/passportsStore";
    import {setFocusTo, setPassport, passportStatus, countPassports} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Modal from '../components/modal/Modal.svelte';
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PassportApiCheck from "../passports/PassportApiCheck.svelte";
    import PassportsCheckTable from "../passports/PassportsCheckTable.svelte";

    export let passportQuantity = null;
    export let autofillPassports = true;
    export let closeCallback;

    let passports = {
        id: 0,
        passport_from: '',
        passport_to: '',
        total: 0,
        status: PASSPORT_STATUS.ASSIGN,
    };
    let quantity = null;
    let conflictList = [];
    let fatalConflict = false;

    let checkPassports = false;
    let checkResult = null;

    const assignToOrder = () => {
        console.log("assignToOrder", passports);
        close(passports);
    }

    const onQuantityChange = () => {
        console.log("onQuantityChange", quantity);
        if (quantity < 1) {
            quantity = 1
        } else if (passportQuantity && quantity > passportQuantity) {
            quantity = passportQuantity;
        }
        if (passports.passport_from) {
            passports.passport_to = setPassport(parseInt(passports.passport_from) + quantity - 1);
            checkPassportRange();
        }
    }

    const onPassportChange = () => {
        if (passports.passport_from) {
            passports.passport_from = setPassport(passports.passport_from);
            checkResult = null
            onQuantityChange();
            checkPassportRange();
        } else {
            passports.passport_to = null;
            conflictList = [];
            fatalConflict = false;
            checkResult = null
        }
    }

    const onSetPassportRange = () => {
        const onSuccess = result => {
            if (result) {
                passports.passport_from = setPassport(result[0]);
                passports.passport_to = setPassport(result[1]);
            }
        }

        const onFailure = err => {

        };

        let data = {
            order_id: 0,
            quantity: quantity
        }
        R.handle(R.passport.getRange, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const checkPassportRange = () => {
        const onSuccess = result => {
            let notAllowedStatus = [
                PASSPORT_STATUS.ASSIGNED,
                PASSPORT_STATUS.DESTROYED,
                PASSPORT_STATUS.ASSIGN,
                PASSPORT_STATUS.RETURN,
                PASSPORT_STATUS.DESTROY,
            ];

            fatalConflict = false;
            conflictList = result;
            conflictList.map(item => {
                if (notAllowedStatus.indexOf(~~item.status) > -1) {
                    fatalConflict = true;
                }
                item.passport_from = $passportsStore.prefix + item.passport_from;
                item.passport_to = $passportsStore.prefix + item.passport_to;
                item.status = passportStatus(item.status);
            });
        }

        const onFailure = err => {
            // error = err.message;
        };

        let data = {
            passport_from: passports.passport_from,
            passport_to: passports.passport_to,
        }

        R.handle(R.passport.checkRange, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const checkComplete = param => {
        checkPassports = false;
        console.log("checkComplete", param);
        if (param) {
            checkResult = param;
            if (checkResult.assigned.length || checkResult.destroyed.length) {
                fatalConflict = true;
            }
        }
    }

    const close = (param) => {
        passports = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    quantity = passportQuantity;

    $: {
        if (passports) {
            passports.total = 0;
            if (passports.passport_from && passports.passport_to) {
                passports.total += countPassports(passports.passport_from, passports.passport_to)
            }
        }
    }
</script>

{#if passports}
    <Modal title="Διαβατήρια" modalSm on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Ποσότητα</label>
                <input type="number" class="form-control" bind:value="{ quantity }" on:change={ onQuantityChange }>
            </div>
            {#if quantity > 0}
                <div class="row mb-3">
                    <div class="col-6 mb-2">
                        <label>Διαβατήρια από</label>
                        <div class="input-group">
                            <span class="input-group-text">{ $passportsStore.prefix }</span>
                            <input type="text" class="form-control" bind:value="{ passports.passport_from }"
                                   oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                   maxlength="6" on:change={ () => onPassportChange() }
                                   disabled="{ passports.synced_at }">
                        </div>
                    </div>
                    <div class="col-6 mb-2">
                        <label>Έως</label>
                        <div class="input-group">
                            <span class="input-group-text">{ $passportsStore.prefix }</span>
                            <div class="form-control">{ passports.passport_to }</div>
                        </div>
                    </div>
                    {#if !passports.passport_from && autofillPassports}
                        <div class="col-12">
                            <button class="btn btn-link p-0" on:click={ onSetPassportRange }>
                                αυτόματη συμπλήρωση
                            </button>
                        </div>
                    {/if}
                </div>
                {#if passports.total > 0}
                    <div class="mb-3">Σύνολο: <b>{ passports.total }</b></div>
                {/if}
            {/if}

            {#if conflictList.length}
                <div class="alert alert-danger p-2 mb-1">
                    Κάποιοι από τους αριθμούς διαβατηρίων είναι σε χρήση!
                </div>
                <table class="table table-list table-sm mb-4">
                    <tbody>
                    {#each conflictList as item}
                        <tr>
                            <td class="ps-0">{ item.passport_from } - { item.passport_to }</td>
                            <td class="pe-0">{ item.status }</td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
            {#if checkResult}
                <PassportsCheckTable status="{ PASSPORT_STATUS.ASSIGNED }" list="{checkResult.assigned}"/>
                <PassportsCheckTable status="{ PASSPORT_STATUS.RETURNED }" list="{checkResult.returned}"/>
                <PassportsCheckTable status="{ PASSPORT_STATUS.DESTROYED }" list="{checkResult.destroyed}"/>
                {#if fatalConflict}
                    <div class="alert alert-danger p-2 mb-1">
                        Κάποιοι από τους αριθμούς διαβατηρίων είναι σε χρήση!
                    </div>
                {:else}
                    <div class="alert alert-info p-2 mb-1">
                        Ο έλεγχος ολοκληρώθηκε!
                    </div>
                {/if}
            {/if}
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                {#if !checkResult}
                    <button class="btn btn-primary px-4" on:click="{ () => checkPassports = true }"
                            disabled="{ !passports.passport_from || !passports.passport_to}">
                        ΕΛΕΓΧΟΣ ΔΙΑΒΑΤΗΡΙΩΝ
                    </button>
                {:else}
                    <button class="btn btn-primary px-4" on:click="{ assignToOrder }">
                        OK
                    </button>
                {/if}
            </div>
        </div>
    </Modal>
{/if}

{#if checkPassports}
    <PassportApiCheck {passports} completeCallback="{ checkComplete }"/>
{/if}